import React, { useState } from 'react';
import { useAuth } from '../contexts/AuthContext';

export default function Settings() {
  const { user, isDarkMode, toggleTheme } = useAuth();
  const [activeTab, setActiveTab] = useState('general');

  // Tab-Definitionen
  const tabs = [
    { id: 'general', name: 'Allgemein', icon: '⚙️' },
    { id: 'system', name: 'System', icon: '🔧' },
  ];

  return (
    <div className="min-h-screen bg-gray-50 dark:bg-gray-900">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        <div className="mb-8">
          <h1 className="text-3xl font-bold text-gray-900 dark:text-white">Einstellungen</h1>
          <p className="mt-2 text-gray-600 dark:text-gray-300">
            Verwalten Sie Ihre System- und Server-Einstellungen
          </p>
        </div>

        <div className="bg-white dark:bg-gray-800 shadow rounded-lg">
          {/* Tab Navigation */}
          <div className="border-b border-gray-200 dark:border-gray-700">
            <nav className="-mb-px flex space-x-8 px-6">
              {tabs.map((tab) => (
                <button
                  key={tab.id}
                  onClick={() => setActiveTab(tab.id)}
                  className={`py-4 px-1 border-b-2 font-medium text-sm whitespace-nowrap transition-colors ${
                    activeTab === tab.id
                      ? 'border-primary text-primary'
                      : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300 dark:text-gray-400 dark:hover:text-gray-300'
                  }`}
                >
                  <span className="mr-2">{tab.icon}</span>
                  {tab.name}
                </button>
              ))}
            </nav>
          </div>

          {/* Tab Content */}
          <div className="p-6">
            {/* Allgemein Tab */}
            {activeTab === 'general' && (
              <div className="space-y-6">
                <div>
                  <h3 className="text-lg font-medium text-gray-900 dark:text-white mb-4">
                    Allgemeine Einstellungen
                  </h3>

                  <div className="space-y-4">
                    <div className="flex items-center justify-between p-4 bg-gray-50 dark:bg-gray-700 rounded-lg">
                      <div>
                        <h4 className="font-medium text-gray-900 dark:text-white">Dark Mode</h4>
                        <p className="text-sm text-gray-500 dark:text-gray-400">
                          Wechseln zwischen hellem und dunklem Design
                        </p>
                      </div>
                      <button
                        onClick={toggleTheme}
                        className={`relative inline-flex h-6 w-11 items-center rounded-full transition-colors ${
                          isDarkMode ? 'bg-primary' : 'bg-gray-200'
                        }`}
                      >
                        <span
                          className={`inline-block h-4 w-4 transform rounded-full bg-white transition-transform ${
                            isDarkMode ? 'translate-x-6' : 'translate-x-1'
                          }`}
                        />
                      </button>
                    </div>

                    <div className="p-4 bg-blue-50 dark:bg-blue-900/20 rounded-lg">
                      <h4 className="font-medium text-blue-900 dark:text-blue-100 mb-2">
                        Benutzerinformationen
                      </h4>
                      <div className="space-y-2 text-sm text-blue-800 dark:text-blue-200">
                        <p>
                          <strong>Benutzername:</strong> {user?.username}
                        </p>
                        <p>
                          <strong>Name:</strong> {user?.firstName} {user?.lastName}
                        </p>
                        <p>
                          <strong>E-Mail:</strong> {user?.email}
                        </p>
                        <p>
                          <strong>Rolle:</strong>{' '}
                          {(() => {
                            if (user?.role === 'dachadmin') return 'Dachadministrator';
                            if (user?.role === 'superadmin') return 'Superadministrator';
                            if (user?.role === 'admin') return 'Administrator';
                            return 'Benutzer';
                          })()}
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            )}

            {/* System Tab */}
            {activeTab === 'system' && (
              <div className="space-y-6">
                <div>
                  <h3 className="text-lg font-medium text-gray-900 dark:text-white mb-4">
                    System-Informationen
                  </h3>

                  <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                    <div className="p-4 bg-gray-50 dark:bg-gray-700 rounded-lg">
                      <h4 className="font-medium text-gray-900 dark:text-white mb-2">
                        Server Status
                      </h4>
                      <div className="space-y-2 text-sm text-gray-600 dark:text-gray-300">
                        <p>
                          <strong>Status:</strong> <span className="text-green-600">🟢 Online</span>
                        </p>
                        <p>
                          <strong>Version:</strong> 0.8.0
                        </p>
                        <p>
                          <strong>Umgebung:</strong> {process.env.NODE_ENV || 'development'}
                        </p>
                      </div>
                    </div>

                    <div className="p-4 bg-gray-50 dark:bg-gray-700 rounded-lg">
                      <h4 className="font-medium text-gray-900 dark:text-white mb-2">Datenbank</h4>
                      <div className="space-y-2 text-sm text-gray-600 dark:text-gray-300">
                        <p>
                          <strong>Status:</strong>{' '}
                          <span className="text-green-600">🟢 Verbunden</span>
                        </p>
                        <p>
                          <strong>Typ:</strong> PostgreSQL
                        </p>
                        <p>
                          <strong>Tabellen:</strong> 6
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
